"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SolidPlugIcon = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement("svg", __assign({ width: "10", height: "17", viewBox: "0 0 10 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.66699L2 1.67741C2 1.40943 2.10536 1.15243 2.29289 0.962938C2.48043 0.773448 2.73478 0.666992 3 0.666992C3.26522 0.666992 3.51957 0.773448 3.70711 0.962939C3.89464 1.15243 4 1.40943 4 1.67741L4 4.66699H6V1.67741C6 1.40943 6.10536 1.15243 6.29289 0.962938C6.48043 0.773448 6.73478 0.666992 7 0.666992C7.26522 0.666992 7.51957 0.773448 7.70711 0.962939C7.89464 1.15243 8 1.40943 8 1.67741V4.66699H8.87146C9.16713 4.66879 9.45018 4.7896 9.65925 5.00324C9.86832 5.21688 9.98655 5.50612 9.98831 5.80824L9.98607 8.30074C10.0196 8.75876 10.0657 10.1678 9.16259 11.5213C8.69607 12.2057 8.07121 12.7617 7.34362 13.1396C6.89287 13.3723 6.43899 13.5138 6 13.5909V15.6566C6 15.9246 5.89464 16.1816 5.70711 16.371C5.51957 16.5605 5.26522 16.667 5 16.667C4.73478 16.667 4.48043 16.5605 4.29289 16.371C4.10536 16.1816 4 15.9246 4 15.6566V13.5593C3.30544 13.4266 2.80118 13.21 2.6432 13.1396C1.01186 12.2769 0.134021 10.8647 0 8.96875V5.80824C0.0017582 5.50612 0.119989 5.21688 0.329058 5.00324C0.538127 4.7896 0.821181 4.66879 1.11684 4.66699H2Z", fill: "#183558" }))); });
exports.default = SolidPlugIcon;
//# sourceMappingURL=SolidPlugIcon.js.map